import { currencyBasedRounding } from "tiers/currency";
class PricingScheme2025 {
    constructor() {
        this.PRICES = {
            boost: {
                gbp: { "month": 4.49, "year": 3.59 },
                usd: { "month": 5.99, "year": 4.79 },
                eur: { "month": 5.19, "year": 4.15 },
                cad: { "month": 6.99, "year": 5.59 },
                aud: { "month": 7.49, "year": 5.99 },
                sgd: { "month": 5.99, "year": 4.79 },
                nzd: { "month": 8.99, "year": 7.19 },
                myr: { "month": 12.99, "year": 10.39 },
                mxn: { "month": 59, "year": 47 },
                cop: { "month": 12000, "year": 9600 },
                inr: { "month": 239, "year": 189 },
            }
        };
        this.SCHOOL_DISCOUNTS_BREAKS = [
            [100, -200],
            [200, 30],
            [500, 40],
            [1000, 50],
            [2000, 60],
            [5000, 70],
            [10000, 75],
            [20000, 80],
            [50000, 85],
        ];
        this.TEAM_DISCOUNTS_BREAKS = [
            [1, 0],
            [2, 50],
            [5, 70],
            [100, 86],
        ];
    }
    price(currency, period) {
        return this.PRICES.boost[currency][period];
    }
    schoolPrice(students, currency, period, showFor = "month") {
        const baseMonthlyPrice = this.PRICES["boost"][currency]["month"];
        // Discount Factor = 10
        const pricePerUser = (baseMonthlyPrice / 10).round(4);
        return discountBreakBasedPricing(students, pricePerUser, this.SCHOOL_DISCOUNTS_BREAKS, currency, { divideByTwelve: showFor === "month", bumpBy25Percent: period === "month" });
    }
    teamPrice(members, currency, period, showFor = "month") {
        const basePrice = this.PRICES["boost"][currency][period] * (period === "year" ? 12 : 1);
        return discountBreakBasedPricing(members, basePrice, this.TEAM_DISCOUNTS_BREAKS, currency, { divideByTwelve: showFor === "month" && period === "year" });
    }
}
class PricingScheme2022 {
    constructor() {
        this.PRICES = {
            boost: {
                gbp: { month: 3.49, year: 2.79 },
                usd: { month: 4.49, year: 3.59 },
                cad: { month: 5.49, year: 4.39 },
                aud: { month: 5.99, year: 4.79 },
                eur: { month: 3.99, year: 3.19 },
                sgd: { month: 4.99, year: 3.99 },
                mxn: { month: 49, year: 39 },
                cop: { month: 8999, year: 7199 },
                myr: { month: 9.99, year: 7.99 },
                inr: { month: 209, year: 169 },
                nzd: { month: 6.99, year: 5.59 },
            }
        };
        // https://docs.google.com/spreadsheets/d/17rcxpODwO_md07ANRoxol9uDBR5-LtWlZ7e7ohaGwJk/edit#gid=1712682288
        this.SCHOOL_DISCOUNTS_BREAKS = [
            [100, -150],
            [200, 0],
            [500, 25],
            [1000, 45],
            [2000, 60],
            [5000, 70],
            [10000, 75],
            [20000, 80],
            [50000, 85],
        ];
    }
    price(currency, period) {
        return this.PRICES.boost[currency][period];
    }
    schoolPrice(students, currency, period, showFor = "month") {
        const baseMonthlyPrice = this.PRICES["boost"][currency]["month"];
        // Discount Factor = 10
        const pricePerUser = (baseMonthlyPrice / 10).round(4);
        return discountBreakBasedPricing(students, pricePerUser, this.SCHOOL_DISCOUNTS_BREAKS, currency, { divideByTwelve: showFor === "month" && period === "year", bumpBy25Percent: period === "month" });
    }
    teamPrice(members, currency, period, showFor = "month") {
        return 0;
    }
}
function discountBreakBasedPricing(seats, basePrice, breaks, currency, opts = {}) {
    var _a, _b;
    let totalPrice = 0;
    let previousBreak = 0;
    for (let [currentBreak, percentDiscount] of breaks) {
        // Max students in this band.
        const maxStudents = currentBreak - previousBreak;
        const pricePerUser = (basePrice * (1 - percentDiscount / 100)).round(4);
        // Calculate price for this band. Round depending on the rounding strategy.
        let priceForBand = Math.min(maxStudents, seats) * pricePerUser;
        priceForBand = priceForBand.round(currencyBasedRounding(currency));
        totalPrice += priceForBand;
        seats -= maxStudents;
        if (seats <= 0)
            break;
        previousBreak = currentBreak;
    }
    if ((_a = opts.divideByTwelve) !== null && _a !== void 0 ? _a : false) {
        totalPrice /= 12;
    }
    if ((_b = opts.bumpBy25Percent) !== null && _b !== void 0 ? _b : false) {
        totalPrice *= 1.25;
    }
    totalPrice = totalPrice.round(currencyBasedRounding(currency));
    return totalPrice;
}
export function getPricingScheme(scheme) {
    switch (scheme) {
        case "original": throw new Error("Original pricing scheme is not supported anymore. Please use 2022 or 2025.");
        case "2022": return new PricingScheme2022();
        case "2025": return new PricingScheme2025();
    }
}
